<div class="VizseekTitle">
    <span>{{'common.vizseek_Search_NOresults'| cxTranslate}}</span>
    <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-kb.svg" alt="" class="close" width="20" />
    </button>
</div>
<mat-dialog-content class="vizseekContent">
       <p [style.white-space]="'pre-line'">{{NOresults}}</p>
</mat-dialog-content>